// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-table-row {
  width: 100%;
  min-height: 15%;
  display: grid;
  flex-direction: row;
  border-bottom: 0.7px solid #DBDBDB;
  justify-content: center;
  align-items: self-start;
  padding: 10px 1rem;
  grid-template-columns: 5% 15% 15% 15% 15% 15% 15% 5%;
  place-items: center;
}
.preview-table-row__label {
  font-size: 0.85rem;
}

.bold {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/preview-table-row/preview-table-row.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,uBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oDAAA;EAGA,mBAAA;AADJ;AAEI;EACI,kBAAA;AAAR;;AAGA;EACI,iBAAA;AAAJ","sourcesContent":[".preview-table-row{\n    width: 100%;;\n    min-height: 15%;\n    display: grid;\n    flex-direction: row;\n    border-bottom: 0.7px solid #DBDBDB;\n    justify-content: center;\n    align-items: self-start;\n    padding: 10px 1rem;\n    grid-template-columns:5% 15% 15% 15% 15% 15% 15% 5% ;\n    //color grid cols;\n    \n    place-items: center;\n    &__label{\n        font-size: 0.85rem;\n    }\n}\n.bold{\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
